import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createSlots as _createSlots, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../public/telegram.jpg'


const _hoisted_1 = { class: "h-full flex flex-col" }
const _hoisted_2 = {
  key: 0,
  style: {"z-index":"999"},
  class: "fixed transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
}
const _hoisted_3 = { class: "flex flex-col flex-grow" }
const _hoisted_4 = {
  class: "sticky top-0",
  style: {"z-index":"1000"}
}
const _hoisted_5 = {
  key: 1,
  style: {"min-height":"1.75rem"},
  class: "shadow-elevation mb-4 bg-gray-100 flex items-center"
}
const _hoisted_6 = { class: "flex w-full px-4 mx-auto md:items-center sm:px-6 lg:px-8" }
const _hoisted_7 = { class: "md:items-center md:flex-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex ml-auto md:w-80" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ml-auto",
    id: "main-student-header-right"
  })
], -1)
const _hoisted_9 = { class: "flex relative flex-grow" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = {
  key: 0,
  class: "relative flex items-center mt-0.5 -ml-0.5"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "material-icons mr-1.5 text-primary text-base" }, "auto_awesome", -1)
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = {
  key: 0,
  class: "flex items-center space-x-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "ml-3 material-icons-outlined text-primary text-base" }, " leaderboard ", -1)
const _hoisted_16 = { class: "" }
const _hoisted_17 = {
  style: {"width":"18px","height":"18px"},
  viewBox: "0 0 24 24"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "mt-4 -mx-2 flex flex-col space-y-1 items-center vsm--footer bg-primary-light bg-opacity-5 px-3 py-4" }
const _hoisted_21 = { class: "mx-auto text-muted text-sm text-center" }
const _hoisted_22 = { class: "text-base md:text-xs xl:text-base 2xl:text-lg" }
const _hoisted_23 = {
  key: 1,
  class: "flex items-center w-full h-12 md:px-6 px-3 py-3 mt-auto text-sm text-darkText bg-light border-t border-gray-200 border-opacity-50 z-50"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<p><span class=\"mr-0.5 text-muted\">©</span><a target=\"_blank\" class=\"font-medium text-primary hover:underline\" href=\"https://evo-learning.com\">Evo Learning</a></p><p class=\"mx-2 text-muted\">·</p><p><span class=\"text-muted\">Crafted with</span> ❤️ <span class=\"text-muted\">by </span><a target=\"_blank\" class=\"font-medium text-primary hover:underline\" href=\"http://bsamu.it\">Samuele Bonini</a></p>", 3)
const _hoisted_27 = {
  target: "_blank",
  id: "terms-and-conditions",
  class: "ml-auto text-primary hover:underline opacity-0 hidden md:block"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://t.me/sai_evo",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-5 h-5 transition-opacity duration-75 opacity-70 hover:opacity-100",
    src: _imports_0
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_AppBar = _resolveComponent("AppBar")!
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_GamificationContextPanel = _resolveComponent("GamificationContextPanel")!
  const _component_DraggablePopup = _resolveComponent("DraggablePopup")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_ErrorView = _resolveComponent("ErrorView")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_SnackBar = _resolveComponent("SnackBar")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.metaStore.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Spinner, {
            size: 'xl',
            variant: 'dark',
            fast: true
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.metaStore._showSuccessFeedback)
          ? (_openBlock(), _createBlock(_component_Notification, {
              key: 0,
              text: _ctx.metaStore.customSuccessFeedbackMessage
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showAppBar)
          ? (_openBlock(), _createBlock(_component_AppBar, {
              key: 0,
              showCollapseSideBarButton: _ctx.showSidebar,
              showMobileSidebarButton: _ctx.showSidebar,
              onToggleSidebarCollapsed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onToggleCollapseSidebar())),
              onToggleMobileSidebar: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onToggleMobileSidebar())),
              showHelpCenterButton: _ctx.showHelpCenterButton,
              showLocaleSelector: _ctx.showLocaleSelector,
              sidebarCollapsed: _ctx.sidebarCollapsed,
              onLogout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logOut())),
              sticky: false
            }, null, 8, ["showCollapseSideBarButton", "showMobileSidebarButton", "showHelpCenterButton", "showLocaleSelector", "sidebarCollapsed"]))
          : _createCommentVNode("", true),
        (_ctx.showSecondaryHeader)
          ? (_openBlock(), _createElementBlock("header", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.$route.meta?.breadcrumbs && !_ctx.$route.meta?.hideBreadcrumbs)
                    ? (_openBlock(), _createBlock(_component_BreadCrumbs, {
                        key: 0,
                        route: _ctx.$route,
                        class: "mt-1 md:ml-0"
                      }, null, 8, ["route"]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_8
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.showSidebar)
          ? (_openBlock(), _createBlock(_component_SideBar, {
              key: 0,
              header: _ctx.currentCourseName,
              sidebarOptions: _ctx.sidebarOptions,
              collapsed: _ctx.sidebarCollapsed,
              showMobileSidebar: _ctx.showMobileSidebar,
              initializing: _ctx.initializingSidebar
            }, _createSlots({ _: 2 }, [
              (!_ctx.isTeacherRoute)
                ? {
                    name: "header",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.mainStore.gamificationContext)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _hoisted_12,
                              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.mainStore.gamificationContext?.reputation ?? 0), 1),
                              (
										_ctx.mainStore.gamificationContext &&
										_ctx.mainStore.gamificationContext.leaderboard_position !== null
									)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.mainStore.gamificationContext.leaderboard_position), 1),
                                    (_ctx.mainStore.gamificationContext.leaderboard_position <= 3)
                                      ? (_openBlock(), _createElementBlock("p", {
                                          key: 0,
                                          class: _normalizeClass({
											'text-yellow-400':
												_ctx.mainStore.gamificationContext.leaderboard_position === 1,
											'text-gray-400':
												_ctx.mainStore.gamificationContext.leaderboard_position === 2,
											'text-yellow-900':
												_ctx.mainStore.gamificationContext.leaderboard_position === 3,
										})
                                        }, [
                                          (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_Btn, {
                                tooltip: _ctx.showGamificationPanel ? '' : _ctx.$t('gamification.show_panel'),
                                variant: 'icon',
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showGamificationPanel = !_ctx.showGamificationPanel)),
                                outline: true
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    style: {"font-size":"20px !important"},
                                    class: _normalizeClass({
											'material-icons-outlined': !_ctx.showGamificationPanel,
											'material-icons': _ctx.showGamificationPanel,
										})
                                  }, "visibility", 2)
                                ]),
                                _: 1
                              }, 8, ["tooltip"]),
                              (_ctx.showGamificationPanel)
                                ? (_openBlock(), _createBlock(_component_DraggablePopup, {
                                    key: 1,
                                    title: '',
                                    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showGamificationPanel = false)),
                                    initialTop: 160,
                                    initialLeft: 1,
                                    opaque: true,
                                    resizable: false,
                                    fullWidth: true
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.showGamificationPanel)
                                        ? (_openBlock(), _createBlock(_component_GamificationContextPanel, {
                                            key: 0,
                                            style: {"margin-top":"-34px"},
                                            class: "w-full"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    key: "0"
                  }
                : undefined,
              (
							_ctx.hasAnyPrivilegesOrIsTeacher && !_ctx.isTeacherRoute && _ctx.$route.params.courseId
						)
                ? {
                    name: "footer",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("student_course_dashboard.you_are_in_student_mode")), 1),
                        _createVNode(_component_router_link, {
                          class: "w-full",
                          to: {
									name: 'TeacherCourseDashboard',
									params: { courseId: _ctx.currentCourse?.id ?? '-1' },
								}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Btn, {
                              variant: 'primary-borderless',
                              class: "w-full"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("courses.course_panel")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]),
                    key: "1"
                  }
                : undefined
            ]), 1032, ["header", "sidebarOptions", "collapsed", "showMobileSidebar", "initializing"]))
          : _createCommentVNode("", true),
        (_ctx.metaStore.pageWideErrorData)
          ? (_openBlock(), _createBlock(_component_ErrorView, {
              key: 1,
              data: _ctx.metaStore.pageWideErrorData
            }, null, 8, ["data"]))
          : (_openBlock(), _createBlock(_component_router_view, {
              key: 2,
              style: _normalizeStyle(
						_ctx.showSidebar
							? _ctx.sidebarCollapsed && _ctx.mediaQueryMd
								? 'width: 100%; padding-left: ' +
								  Math.max(_ctx.routerViewPaddingLeft + 30, 100) +
								  'px; padding-right: 30px'
								: (!_ctx.sidebarCollapsed && _ctx.mediaQueryMd
										? 'padding-left: calc(16.66667% + 30px); width: 100%; padding-right: 30px'
										: '') +
								  (!_ctx.mediaQueryMd
										? 'width: 100%; padding-left: 12px; padding-right: 12px'
										: '')
							: _ctx.isPublicCourseRoute
							? 'width: 100%'
							: ''
					),
              class: "px-2 md:px-6 lg:px-10 py-4"
            }, null, 8, ["style"])),
        _createVNode(_Transition, { name: "quick-bounce" }, {
          default: _withCtx(() => [
            (_ctx.metaStore.errorNotificationData)
              ? (_openBlock(), _createBlock(_component_SnackBar, {
                  key: 0,
                  class: "w-full px-4 pb-10",
                  icon: _ctx.metaStore.errorNotificationData.icon,
                  message: _ctx.metaStore.errorNotificationData.title
                }, null, 8, ["icon", "message"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.showFooter)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("a", _hoisted_27, _toDisplayString(_ctx.$t("misc.terms_and_conditions")), 1),
          (!_ctx.isDemoMode)
            ? (_openBlock(), _createBlock(_component_Tooltip, {
                key: 0,
                placement: 'left',
                class: "ml-auto md:ml-4",
                textCode: 'telegram'
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}